import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusPostaComponent } from './status-posta.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [StatusPostaComponent],
    imports: [
        CommonModule,
        MaterialModule,
    ],
    exports: [StatusPostaComponent]
})
export class StatusPostaModule { }
